import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { App } from '@df/core/app';
import { UiComponent } from '@df/ui/ui.component';
import { Product } from '../../../catalog/product/product.decorator';
import { ReviewsIOService } from '../reviews-io.service';

@Component({
    selector: 'reviews-io-carousel',
    template: '<div class="bg-col-w wrap" id="reviewsio-carousel-widget"></div>',
    standalone: true
})
export class ReviewsIOCarouselComponent extends UiComponent implements AfterViewInit, OnChanges {
    @Input({ required: true })
    product!: Product;


    app = inject(App);

    private reviewsIOService = inject(ReviewsIOService);

    ngAfterViewInit(): void {
        this.reviewsIOService.updateCarousel(this.product);
    }

    override ngOnChanges(changes: SimpleChanges): void {
        if (changes['product'] && this.initiated) {
            this.reviewsIOService.updateCarousel(this.product);
        }
        super.ngOnChanges(changes);
    }
}
